import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import { audiences } from "@/mocks/siteData";

export default function AudiencesSection() {
  return (
    <section className="sun-glaze bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal className="lg:col-span-4 lg:sticky lg:top-28">
            <div className="flex items-center gap-3 mb-5">
              <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
                Lasting Connections
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
              More Than a Weekend Trip
            </h2>
            <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
              A Rythugaru experience is designed to create lasting connections — for every age and
              every kind of traveler.
            </p>
          </Reveal>

          <Reveal className="lg:col-span-8" delay={120}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {audiences.map((item) => (
                <div
                  key={item.title}
                  className="bg-background-100 rounded-lg p-6 border border-background-200 hover:border-primary-300 transition-colors"
                >
                  <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <h3 className="font-heading text-xl text-foreground-950 font-semibold mt-4">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mt-2">{item.text}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}